import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

const KEY = ["academic-years"];

/** { years: [...], current: "2026-27", next: "2027-28", isLoading } */
export function useAcademicYear(enabled = true) {
  const { data, isLoading } = useQuery({
    queryKey: KEY,
    queryFn: async () => (await api.get("/school/academic-years")).data,
    staleTime: 5 * 60_000,
    enabled,
  });
  return {
    years: data?.years || [],
    current: data?.current || "",
    next: data?.next || "",
    isLoading,
  };
}

/** Year <select> options: the school's years unioned with a few recent ones so
 *  historical data is still selectable. `current` is the running year. */
export function useYearOptions() {
  const { years, current } = useAcademicYear();
  const y = new Date().getFullYear();
  const recent = [-2, -1, 0, 1].map((d) => `${y + d}-${String(y + d + 1).slice(-2)}`);
  const all = Array.from(new Set([...(current ? [current] : []), ...years, ...recent])).sort();
  return { years: all, current: current || recent[2] };
}

export function useAcademicYearMutations() {
  const qc = useQueryClient();
  const done = () => {
    qc.invalidateQueries({ queryKey: KEY });
    qc.invalidateQueries({ queryKey: ["students"] });
  };
  return {
    add: useMutation({ mutationFn: async (year) => (await api.post("/school/academic-years", { year })).data, onSuccess: done }),
    setCurrent: useMutation({ mutationFn: async (year) => (await api.put("/school/academic-years/current", { year })).data, onSuccess: done }),
    remove: useMutation({ mutationFn: async (year) => (await api.delete(`/school/academic-years/${year}`)).data, onSuccess: done }),
  };
}
